<template>
  <div class="dimissionRecord">
    <OATable :data="data" :columns="columns" :filterData="filterData" :selectionRow="true" @search="handleSearch"
      @selectionChange="selectionChange" :loading="loading">
      <div slot="button">
        <OAButton @click="handleOpen" :disabled="!checkList.length">复职</OAButton>
        <a :href="herf" download="离职员工档案.xlsx">
          <OAButton class="pull-right" v-permission="'quitAll'">导出全部</OAButton>
        </a>
      </div>
    </OATable>
    <OAModalForm title="复职" :visible.sync="dialogVisible" :form-data="formData" @on-submit="submit"
      @on-cancel="dialogVisible = false"></OAModalForm>
  </div>
</template>
<script>
  import OAModalForm from "@/components/OAModalForm/OAModalForm";
  import {
    resFilter,
    getToday
  } from "@/common/util.js";
  import {
    validMobile,
    validateNozho
  } from "@/common/valid.js";
  import OAJump from "@/components/OAJump/OAJump";
  import api from "@/api/apiConfig";
  import dimissionApi from "@/services/dimission.js";

  export default {
    name: "dimissionRecord",
    components: {
      OAModalForm,
      OAJump
    },
    data() {
      return {
        herf: '/api' + api.dimission.exportAll + localStorage.getItem("Authorization"),
        filterData: {
          inputName: {
            formType: "a-input",
            value: undefined,
            col: 4,
            placeholder: "姓名 / 工号 / 英文名"
          },
          companyId: {
            formType: "a-select",
            value: undefined,
            col: 4,
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            },
            placeholder: "所属公司",
            options: []
          },
          inductionTimeList: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "入职开始日期",
            endPlaceholder: "入职结束日期",
            col: 4
          },
          departureTimeList: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "离职开始日期",
            endPlaceholder: "离职结束日期",
            col: 4
          }
        },
        columns: [{
            title: "姓名",
            key: "name",
            component: {
              name: OAJump,
              props: {
                textKey: "name",
                paramKey: "userId",
                url: "dimissionDetail"
              }
            },
            minWidth: 100
          },
          {
            title: "工号",
            key: "number"
          },
          {
            title: "英文名",
            key: "englishName"
          },
          {
            title: "性别",
            key: "sexName"
          },
          {
            title: "所属公司",
            key: "companyName",
            minWidth: 200,
            showOverflowTooltip: true
          },
          {
            title: "直属部门",
            key: "departmentName",
            minWidth: 150,
            showOverflowTooltip: true
          },
          {
            title: "职位",
            key: "positionName",
            minWidth: 150,
            showOverflowTooltip: true
          },
          {
            title: "员工类型",
            key: "employeeTypeName"
          },
          {
            title: "入职日期",
            key: "inductionTime",
            minWidth: 100
          },
          {
            title: "离职日期",
            key: "departureTime",
            minWidth: 100
          }
        ],
        data: [],
        dialogVisible: false,
        loading: false,
        checkList: [],
        formData: {},
        param: {}
      };
    },
    methods: {
      async handleSearch(val) {
        this.loading = true;
        this.param = val;
        let res = await dimissionApi.getDimiss(val);
        this.data = res.data.data;
        this.loading = false;
      },
      selectionChange(val) {
        this.checkList = val;
      },
      handleOpen() {
        if (this.checkList.length == 1) {
          this.dialogVisible = true;
          this.formData = {
            name: {
              formType: "a-span",
              label: "姓名：",
              value: this.checkList[0].name
            },
            companyId: {
              formType: "a-select",
              label: "所在公司：",
              value: this.checkList[0].companyId,
              options: [],
              api: "getCompany",
              props: {
                label: "companyName",
                value: "id"
              },
              placeholder: "请选择所在公司",
              rules: [{
                required: true,
                message: "请选择所在公司"
              }]
            },
            departmentIds: {
              formType: "a-depart-cascader",
              label: "所在部门：",
              value: this.checkList[0].departmentIds,
              placeholder: "请选择所在部门",
              rules: [{
                required: true,
                message: "请选择所在部门",
                trigger: "change"
              }],
              change: (formData, item) => {
                formData.positionId.departId = _.last(item.value);
              }
            },
            positionId: {
              formType: "a-post-select",
              label: "职位：",
              value: this.checkList[0].positionId,
              departId: _.last(this.checkList[0].departmentIds),
              placeholder: "请选择职位",
              props: {
                label: "positionName",
                value: "id"
              },
              rules: [{
                required: true,
                message: "请选择职位",
                trigger: "change"
              }]
            },
            inductionTime: {
              formType: "a-date-picker",
              label: "入职时间：",
              value: getToday(),
              placeholder: "请选择入职时间",
              rules: [{
                required: true,
                message: "请选择入职时间"
              }]
            },
            number: {
              formType: "a-get-number",
              value: this.checkList[0].number,
              label: "工号：",
              placeholder: "请获取工号",
              companyId: this.checkList[0].companyId,
              rules: [{
                required: true,
                message: "请获取工号"
              }]
            },
            employeeType: {
              formType: "a-select",
              options: [],
              code: 108,
              label: "员工类型：",
              value: this.checkList[0].employeeType,
              placeholder: "请选择员工类型",
              rules: [{
                required: true,
                message: "请选择员工类型"
              }]
            },
            mobile: {
              formType: "a-input",
              value: this.checkList[0].mobile,
              placeholder: "请输入手机号码",
              label: "手机号码：",
              rules: [{
                  required: true,
                  message: "请输入手机号码"
                },
                validMobile()
              ]
            },
            companyEmail: {
              formType: "a-input-select",
              value: [this.checkList[0].companyEmail, this.checkList[0].domainName],
              placeholder: "英文名_姓",
              api: "getcompanydomains",
              label: "企业邮箱：",
              rules: [{
                  required: true,
                  message: "请输入邮箱",
                  trigger: "change"
                },
                {
                  trigger: "change",
                  validator: validateNozho
                }
              ]
            }
          };
        } else {
          this.$message.warning("不支持批量操作");
        }
      },
      async submit(val) {
        val.inductionTime += " 00:00:00";
        if (val.companyEmail && val.companyEmail.length) {
          val.domainName = val.companyEmail[1];
          val.companyEmail = val.companyEmail[0];
        }
        val["id"] = this.checkList[0].id;
        let res = await dimissionApi.resume(val);
        resFilter(res, this.handleSearch(this.param));
        this.dialogVisible = false;
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/pages/personnel/dimissionRecord.vue